/** Sentinel for legacy WebSocket stop flows without a jobs API id. */
export const LEGACY_JOB_STOP_PENDING_ID = '__legacy_stop__';

export function normalizeJobActionStatus(status: string | undefined | null): string {
  return String(status || '').trim().toLowerCase();
}

export function isJobCancellationInProgressStatus(status: string | undefined | null): boolean {
  return normalizeJobActionStatus(status) === 'cancelling';
}

export function isJobCancellationPending(
  jobId: string | null | undefined,
  cancellingId: string | null | undefined,
  status?: string | null
): boolean {
  const id = String(jobId ?? '').trim();
  if (!id) return false;
  if (String(cancellingId ?? '').trim() === id) return true;
  return isJobCancellationInProgressStatus(status);
}

export function isLegacyJobStopPending(cancellingId: string | null | undefined): boolean {
  return cancellingId === LEGACY_JOB_STOP_PENDING_ID;
}

export function getJobCancelButtonLabel(pending: boolean, fallback = 'Cancel'): string {
  return pending ? 'Cancelling…' : fallback;
}

export function getJobStopButtonLabel(stopping: boolean): string {
  return stopping ? 'Stopping…' : 'Stop';
}

export function clearJobCancellationPendingId(
  current: string | null,
  jobId: string | null | undefined
): string | null {
  const id = String(jobId ?? '').trim();
  if (!id || !current) return current;
  return current === id ? null : current;
}
